export enum ECompanionAgilityType {
  Arrow,
  Color,
  Shape,
  Number
}